module.exports = "/../../dist/frontend/images/utilitaire.webp?9151e6fe211b757a5fa3b2f1b6b2a149";